export default "__VITE_ASSET__VDFD3mqf__"